(function () {
  // The zoom dialog's pinch/pan handler (drag-zoom-wrapper) claims every touch
  // gesture on the image, including a plain one-finger swipe at 1x zoom — it just
  // resets translate back to 0 each frame, so the swipe is silently swallowed and
  // the photo never advances. This adds swipe-to-next/prev on top, without touching
  // that shared component: it listens in the same bubble phase (drag-zoom-wrapper
  // never calls stopPropagation), and only acts once a gesture ends as a clean
  // horizontal swipe while the image isn't zoomed in — so pinch-zoom and panning a
  // zoomed photo keep working exactly as before.
  var SWIPE_THRESHOLD = 50;

  function bind(dialog) {
    if (dialog.__aviiroSwipeBound) return;
    dialog.__aviiroSwipeBound = true;

    var startX = 0;
    var startY = 0;
    var tracking = false;

    dialog.addEventListener(
      'touchstart',
      function (event) {
        if (event.touches.length !== 1) {
          tracking = false;
          return;
        }
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
        tracking = true;
      },
      { passive: true }
    );

    dialog.addEventListener(
      'touchend',
      function (event) {
        if (!tracking) return;
        tracking = false;

        var touch = event.changedTouches[0];
        if (!touch) return;

        var dx = touch.clientX - startX;
        var dy = touch.clientY - startY;
        if (Math.abs(dx) < SWIPE_THRESHOLD || Math.abs(dx) < Math.abs(dy) * 1.5) return;

        var wrapper = dialog.querySelector('drag-zoom-wrapper');
        var scale = wrapper ? parseFloat(getComputedStyle(wrapper).getPropertyValue('--drag-zoom-scale')) : 1;
        if (scale && scale > 1.05) return;

        var thumbs = dialog.querySelectorAll('.dialog-thumbnails-list__thumbnail');
        if (thumbs.length < 2) return;

        var activeIndex = -1;
        thumbs.forEach(function (thumb, index) {
          if (thumb.getAttribute('aria-selected') === 'true') activeIndex = index;
        });
        if (activeIndex === -1) return;

        var nextIndex = dx < 0 ? activeIndex + 1 : activeIndex - 1;
        if (nextIndex < 0 || nextIndex >= thumbs.length) return;

        thumbs[nextIndex].click();
      },
      { passive: true }
    );
  }

  function init() {
    document.querySelectorAll('[id$="__main"] .dialog-zoomed-gallery__dialog').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
